import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const TrashIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 3V4H4V6H5V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V6H20V4H15V3H9ZM7 6H17V20H7V6ZM9 8V18H11V8H9ZM13 8V18H15V8H13Z"/>
  </svg>
);
const DupeIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  </svg>
);
const ArrowIcon = () => (
  <svg width="8" height="8" viewBox="0 0 24 24" fill="white">
    <path d="M8 5v14l11-7z"/>
  </svg>
);

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const label = data.label || "";
  const preview = typeof label === "string" ? label.slice(0, 140) : "";

  return (
    <div style={{
      background: "#ffffff",
      borderRadius: 14,
      border: "1.5px solid rgba(59, 130, 246, 0.18)",
      boxShadow: "0 4px 16px rgba(59, 130, 246, 0.10), 0 1px 4px rgba(0,0,0,0.04)",
      minWidth: 220,
      maxWidth: 260,
      fontFamily: "Inter, ui-sans-serif, system-ui, sans-serif",
      position: "relative",
      overflow: "visible",
    }}>
      {/* Action buttons */}
      <div style={{
        position: "absolute",
        top: -32,
        right: 0,
        display: "flex",
        gap: 6,
      }}>
        <button
          style={{
            width: 26, height: 26, borderRadius: "50%",
            background: "#3b82f6", border: "none",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: "#fff",
          }}
          title="Duplicar"
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
        >
          <DupeIcon />
        </button>
        <button
          style={{
            width: 26, height: 26, borderRadius: "50%",
            background: "#ef4444", border: "none",
            display: "flex", alignItems: "center", justifyContent: "center",
            cursor: "pointer", color: "#fff",
          }}
          title="Excluir"
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
        >
          <TrashIcon />
        </button>
      </div>

      {/* Input handle */}
      <Handle
        type="target"
        position="left"
        style={{
          background: "#3b82f6",
          width: 14, height: 14,
          left: -8, top: 28,
          border: "2px solid #fff",
          boxShadow: "0 2px 8px rgba(59,130,246,0.35)",
        }}
        isConnectable={isConnectable}
      >
        <ArrowIcon />
      </Handle>

      {/* Header */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "12px 14px 10px",
        borderBottom: "1px solid rgba(59,130,246,0.08)",
      }}>
        <div style={{
          width: 28, height: 28,
          borderRadius: 8,
          background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0,
          boxShadow: "0 4px 10px rgba(59,130,246,0.28)",
        }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
          </svg>
        </div>
        <span style={{ fontWeight: 700, fontSize: 13, color: "#0f172a", letterSpacing: "-0.01em" }}>
          Mensagem
        </span>
      </div>

      {/* Content */}
      <div style={{ padding: "10px 12px 12px" }}>
        {preview ? (
          <div style={{
            background: "#f8fafc",
            border: "1px solid rgba(59,130,246,0.10)",
            borderRadius: 10,
            padding: "8px 10px",
            fontSize: 12,
            color: "#374151",
            lineHeight: 1.55,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
          }}>
            {preview}
          </div>
        ) : (
          <div style={{
            background: "#f8fafc",
            border: "1px dashed rgba(59,130,246,0.25)",
            borderRadius: 10,
            padding: "10px",
            fontSize: 11.5,
            color: "#94a3b8",
            fontStyle: "italic",
            textAlign: "center",
            lineHeight: 1.5,
          }}>
            Clique duplo para configurar...
          </div>
        )}

        {/* Output row */}
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          marginTop: 8,
          gap: 6,
          paddingRight: 4,
        }}>
          <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500 }}>Próxima etapa</span>
        </div>
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#6366F1",
          width: 14, height: 14,
          right: -8, bottom: 18, top: "auto",
          border: "2px solid #fff",
          boxShadow: "0 2px 8px rgba(99,102,241,0.35)",
        }}
        isConnectable={isConnectable}
      >
        <ArrowIcon />
      </Handle>
    </div>
  );
});
